var exports = {
  "k": "x4ddf2309--0620da--container",
  "M": "x4ddf2309--0620da--units",
};

module.exports = exports;
